import React from 'react';
import { styled, css, useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

export interface ISvg extends IIcon {
  type?: 'move' | 'pause';
}

const Svg = styled.svg`
  ${({ type }) =>
    type === 'pause' &&
    css`
      transform: rotate(90deg);
    `}
`;

const Icon = React.forwardRef<SVGSVGElement | null, ISvg>(function Icon({ size = 24, alt, color, className, onClick, type }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <Svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className} type={type}>
      <rect x='5' y='14' width='14' height='2' fill={fillColor} />
      <rect x='5' y='8' width='14' height='2' fill={fillColor} />
    </Svg>
  );
});

export default React.memo(Icon);
